import identity from 'lodash/identity';
import { combineReducers } from 'redux';
import * as types from '../../actions/actionTypes';
import * as clearStore from './clearStore';
import saveToMyAccountSuccess from './saveToMyAccountSuccess';
import shareEstimateSuccess from './shareEstimateSuccess';
import * as estimateLoaded from './estimateLoaded';
import * as closeEstimate from './closeEstimate';
import * as containerDeleted from './containerDeleted';

const byIdActions = {
  [types.CLEAR_STORE]: clearStore.byId,
  [types.SAVE_TO_MY_ACCOUNT_SUCCESS]: saveToMyAccountSuccess,
  [types.share.SHARE_ESTIMATE_SUCCESS]: shareEstimateSuccess,
  [types.ESTIMATE_LOADED]: estimateLoaded.byId,
  [types.CLOSE_ESTIMATE]: closeEstimate.byId,
  [types.CONTAINER_DELETED]: containerDeleted.byId,
};

const allIdsActions = {
  [types.CLEAR_STORE]: clearStore.allIds,
  [types.ESTIMATE_LOADED]: estimateLoaded.allIds,
  [types.CLOSE_ESTIMATE]: closeEstimate.allIds,
};

const byId = (state = {}, action) => {
  const act = byIdActions[action.type] || identity;
  return act(state, action);
};

const allIds = (state = [], action) => {
  const act = allIdsActions[action.type] || identity;
  return act(state, action);
};

const estimatesReducer = combineReducers({
  byId,
  allIds,
});

export default estimatesReducer;
